const types = {
    FETCH_CATEGORY_SUCCESS: 'FETCH_CATEGORY_SUCCESS',
    FETCH_CATEGORY_FAILED: 'FETCH_CATEGORY_FAILED',
    SHOW_LOADING_CATEGORY: 'SHOW_LOADING_CATEGORY',
};

export default types;